import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom, take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  PATROL_PLATFORM_FLAG_DESCRIPTION,
  PATROL_PLATFORM_FLAG_KEY,
} from '../constants/patrol-platform-flag-keys.constants';
import type { PatrolPlatformFlags } from './patrol-platform-flags.service';

interface FeatureFlagRow {
  key: string;
  enabled: boolean;
  description: string;
}

@Injectable({ providedIn: 'root' })
export class PatrolPlatformFlagsAdminService {
  #http = inject(HttpClient);

  async getPlatformFlags(): Promise<PatrolPlatformFlags> {
    const [discordFlag, robloxFlag] = await Promise.all([
      this.#getFlag(PATROL_PLATFORM_FLAG_KEY.DISCORD),
      this.#getFlag(PATROL_PLATFORM_FLAG_KEY.ROBLOX),
    ]);
    return {
      discord: discordFlag.enabled,
      roblox: robloxFlag.enabled,
    };
  }

  async setDiscordEnabled(enabled: boolean): Promise<void> {
    await this.#upsertFlag(PATROL_PLATFORM_FLAG_KEY.DISCORD, enabled);
  }

  async setRobloxEnabled(enabled: boolean): Promise<void> {
    await this.#upsertFlag(PATROL_PLATFORM_FLAG_KEY.ROBLOX, enabled);
  }

  async #getFlag(key: string): Promise<FeatureFlagRow> {
    return lastValueFrom(
      this.#http
        .get<FeatureFlagRow>(
          `${environment.baseUrl}/user/feature-flags/${encodeURIComponent(key)}`,
        )
        .pipe(take(1)),
    );
  }

  async #upsertFlag(key: string, enabled: boolean): Promise<void> {
    await lastValueFrom(
      this.#http
        .post(`${environment.baseUrl}/user/feature-flags`, {
          key,
          enabled,
          description:
            PATROL_PLATFORM_FLAG_DESCRIPTION[
              key as keyof typeof PATROL_PLATFORM_FLAG_DESCRIPTION
            ] ?? '',
        })
        .pipe(take(1)),
    );
  }
}
